import React from 'react';
import { CircularProgress } from '@material-ui/core';

const LoadingInCustom = ({ loading = false, isTextLoading = false, colorLoading = '' }) => {
  return (
    loading && (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection:'column',
          alignItems:'center',
          marginTop: 60,
          backgroundColor: 'var(--white)',
        }}
      >
        <CircularProgress style={{ color: colorLoading ? colorLoading : ''}} color={'secondary'} />
        {
          isTextLoading && <span>SMS送信中です...</span>
        }
      </div>
    )
  );
};

export default LoadingInCustom;
